import {handleMsg} from '../util/msgUtil.js'
import {sendMsg} from './socketSender.js'
import {webGetAutomaticReply} from '../network/web/automatic-reply.js'
import {getCustomByWxid} from '../network/local/custom.js'

// 处理文本消息
export function _Text(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理图片消息
export function _Image(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理语音消息
export function _Voice(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理视频消息
export function _Video(bean, vthis, socket) {
	handleRMsg(bean, vthis, socket)
}

// 处理小程序消息
export function _Applet(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理红包消息
export function redPackage(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理转账消息
export function transferAccounts(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理自定义表情
export function _CustomImage(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理链接消息
export function _Link(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理视频号消息
export function _Finder(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理视频号直播消息
export function _FinderLive(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理位置消息
export function _Position(bean, vthis, socket) {
	handleRMsg(bean, vthis)
}

// 处理系统消息
export function _System(bean, vthis, socket) {
	handleMsg(bean, vthis)
}

// 消息同步-普通消息
export function _TextOnPhone(bean, vthis) {
	this.handleSyncMsg(bean, vthis, 'text')
}

// 消息同步-图片消息
export function _ImageOnPhone(bean, vthis) {
	this.handleSyncMsg(bean, vthis, 'image')
}

// 消息同步-视频消息
export function _VideoOnPhone(bean, vthis) {
	this.handleSyncMsg(bean, vthis, 'video')
}

// 消息同步-语音消息
export function _VoiceOnPhone(bean, vthis) {
	this.handleSyncMsg(bean, vthis, 'voice')
}

// 消息基本处理，区分群消息和普通消息-接收到的消息
export function handleRMsg(bean, vthis) {
	handleMsg(bean, vthis)
	// 离线回复
	let managerStatus = vthis.$store.state.managerStatus
	if(managerStatus === 0 && bean.msgType == 1){
		webGetAutomaticReply(bean.friendId,res=>{
			if(!res){
				return
			}
			let msg = res.content
			if(msg === "" || msg === undefined){
				return
			}
			getCustomByWxid( bean.toId,custom=>{
				if(custom.id === undefined){
					return
				}
				let chatUser = {
					 type: 1,
					 custom_wx_id: bean.toId,
					 fans_wx_id:bean.fromId,
					 fans_id:bean.friendId,
					 phone_id: custom.phone_id
				}
				sendMsg(chatUser,msg,'text',vthis)
			})
		})
	}	
}

// 处理客服同步消息
export function handleSyncMsg(bean, vthis, type) {
	let is_send = 1
	if(bean.is_send !== undefined){
		is_send = bean.is_send
	}
	let data = {
		content: bean.content,
		friendId: bean.friendId,
		fromId: bean.fromId,
		msgType: 1,
		recentlyId: bean.recentlyId,
		recodeId: bean.recodeId,
		time: (new Date()).getTime(),
		toId: bean.toId,
		is_me: 1,
		is_send: is_send,
		type: type
	}
	// 渲染消息
	handleMsg(data, vthis)
}
